import React from 'react';
import type { ToutWithSwiperSliceProps } from '@ww-digital/web-palette-react/dist/components/Slice/ToutWithSwiperSlice/ToutWithSwiperSlice';

import { ToutWithSwiperSlice } from '@ww-digital/web-palette-react/dist/components/Slice/ToutWithSwiperSlice/ToutWithSwiperSlice';

interface ToutWithSwiperSliceContainerProps {
  daCategory: string;
  slice: ToutWithSwiperSliceProps;
}

export const ToutWithSwiperSliceContainer = ({
  slice,
}: ToutWithSwiperSliceContainerProps): JSX.Element => {
  const sliceContainer = <ToutWithSwiperSlice {...slice} />;

  return <div>{sliceContainer}</div>;
};
